import { ICarrierContactPerState } from "../types";
import CarrierContacts from "./CarrierContacts";
import { useRecoilState } from "recoil";
import { carrierContactPerState } from "../atom/atoms";

const CarrierContactPerState = (): JSX.Element => {
  const [contactsPerState] = useRecoilState<Array<ICarrierContactPerState>[]>(
    carrierContactPerState
  );
  return (
    <div className="mt-2 bg-white box-shadow rounded-lg h-full pb-4">
      <div className="px-3 py-2 text-primary font-bold text text-xs">
        Carrier Contact Per State
      </div>
      {contactsPerState.length > 0 &&
        contactsPerState.map((contact, i) => {
          return (
            <div key={i}>
              <CarrierContacts
                carrierContacts={contact}
                showStateFields={true}
              />
            </div>
          );
        })}
    </div>
  );
};

export default CarrierContactPerState;
